/* eslint-disable */

import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  TextField,
  FormControl,
  Checkbox,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import addCommas from '../../utils/functions/commas';
import NotFound from '../../assets/images/NotFound.jpg';

function DetailRejectSuperAdminPopup({ open, onClose, rowData }) {
  const [finalConfirmationOpen, setFinalConfirmationOpen] = useState(false);
  const [rejectReasonPopupOpen, setRejectReasonPopupOpen] = useState(false);

  const handleReject = () => {
    setRejectReasonPopupOpen(true);
  };

  const handleFinalConfirmationOpen = () => {
    onClose(); // Close the DetailRejectSuperAdminPopup
    setFinalConfirmationOpen(true); // Open the final confirmation popup
  };

  const handleFinalConfirmationClose = () => {
    setFinalConfirmationOpen(false);
  };

  const handleRejectReasonClose = () => {
    setRejectReasonPopupOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '950px',
          },
        }}
      >
        <DialogActions sx={{ justifyContent: 'flex-end' }}>
          <IconButton onClick={onClose} sx={{ color: '#8B8888' }}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
            }}
          >
            รายละเอียดรายการปฏิเสธ
          </Box>
        </DialogTitle>
        <DialogContent>
          {rowData && (
            <Grid
              container
              spacing={2}
              sx={{
                width: '100%',
                maxWidth: '1000px',
                marginTop: '20px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              {/* Detail Fields */}
              <Grid item xs={6} sm={6} md={3}>
                <div>เลขอ้างอิงรายการชำระเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.upload_ref_id || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>ชื่อร้านค้า : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.company_name || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>เลขอ้างอิงรายการของร้านค้า : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.order_id || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>ธนาคาร : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.bank || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>วันที่ชำระเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.date_pay
                    ? dayjs(rowData.date_pay, 'YYYYMMDD').format('DD-MM-YYYY')
                    : '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>เวลาที่ชำระเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.time_pay
                    ? dayjs(rowData.time_pay, 'HHmm').format('HH:mm')
                    : '-'}{' '}
                  น.
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>จำนวนเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.amount ? addCommas(rowData.amount) : '-'} บาท
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>จำนวนเงินทั้งสิ้น :</div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.total_amount ? addCommas(rowData.total_amount) : '-'}{' '}
                  บาท
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>หลักฐาน : </div>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {rowData.image && rowData.image.length > 0 ? (
                    rowData.image.map((imageBase64, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <img
                          src={`data:image/jpg;base64,${imageBase64}`}
                          alt={`evidence-${index}`}
                          style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '400px',
                            maxHeight: '800px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            marginBottom: '50px',
                          }}
                        />
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <img
                        src={NotFound}
                        alt="Not found"
                        style={{
                          width: '100%',
                          height: 'auto',
                          maxWidth: '400px',
                          maxHeight: '800px',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          marginBottom: '50px',
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                sx={{
                  width: '100%',
                  maxWidth: '1000px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: '50px',
                }}
              >
                <Grid item xs={6} sm={6} md={3}>
                  <div>หมายเหตุ : </div>
                </Grid>
                <Grid item xs={5} sm={6} md={9}>
                  <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                    {(() => {
                      try {
                        const noteRejectArray = JSON.parse(
                          rowData.note_reject_array,
                        );
                        if (Array.isArray(noteRejectArray)) {
                          return noteRejectArray.join(', ');
                        }
                      } catch (e) {}
                      return '-';
                    })()}{' '}
                    {rowData.note_reject_string || '-'}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default DetailRejectSuperAdminPopup;
